import {
  HomePage,
  NotFoundPage,
  BlogPage,
  CareersPage,
  ContactUsPage,
  MediaCentrePage,
  SustainabilityPage,
  PhilosophyPage,
  // LeadershipPage,
  AboutFounderPage,
  ChairmanMessagePage,
  BoardOfDirectorsPage,
  LeadershipTeamPage,
  ApartmentsPage,
  VillasPage,
  // VillamentsPage,
  PenthousesPage,
  CommercialPage,
  // ContractingPage,
} from "../pages";

// Ensure routes keys exactly match PAGE_CONTENT keys
export const routes = {
  "/": HomePage,
  "/contact-us": ContactUsPage,
  "/blog": BlogPage,
  "/careers": CareersPage,
  "/media-centre": MediaCentrePage,
  "/sustainability": SustainabilityPage,
  "/who-we-are/philosophy": PhilosophyPage,
  // "/who-we-are/leadership": LeadershipPage,
  "/who-we-are/about-founder": AboutFounderPage,
  "/who-we-are/chairman-message": ChairmanMessagePage,
  "/who-we-are/board-of-directors": BoardOfDirectorsPage,
  "/who-we-are/leadership-team": LeadershipTeamPage,
  "/what-we-do/residential/apartments": ApartmentsPage,
  "/what-we-do/residential/villas": VillasPage,
  // "/what-we-do/residential/villaments": VillamentsPage,
  "/what-we-do/residential/penthouses": PenthousesPage,
  "/what-we-do/commercial": CommercialPage,
  // "/what-we-do/contracting": ContractingPage,
  // Fallback route for unknown paths
  "*": NotFoundPage,
};
